import { defineReceiver } from '@drapejs/invoker';
import { fetchPage } from '@drapejs/core';
import { batch } from '@distancify/drapejs-litium';
import { gql } from 'graphql-request';
import { getProductCacheKey, getVariantCacheKey } from '@/composables/usePdp';

export default defineReceiver(fetchPage, async function (command, data) {
  if (
    data?.component?.toLowerCase()?.indexOf('product') < 0 ||
    !data.articleNumber
  ) {
    return data;
  }

  this.invoke(batch.scheduleQuery, {
    cacheKey: getProductCacheKey(data.articleNumber),
    query: gql`
      baseProduct(id: $baseProductId) {
        id
        fieldsJson
        images {
          id
          filename
        }
        purchaseQuantityMultiplier
        baseProductBreadCrumbs {
          name
          systemId
          url
        }
        brandLogotype {
          id
          width
          height
        }
        brandSlug
        numberOfReviews
        googleAnalyticsName
        googleAnalyticsCategoryPath
        variants {
          id
          inactive
          fields
          prices {
            originalPrice
            campaignPrice
          }
          technicalSpecifications {
            id
            name
            value
          }
        }
        technicalSpecifications {
          id
          name
          value
        }
      }`,
    variables: {
      baseProductId: {
        value: data.articleNumber,
        type: 'String',
      },
    },
  });

  this.invoke(batch.scheduleQuery, {
    cacheKey: getVariantCacheKey(
      data.articleNumber,
      command.query?.variant || ''
    ),
    query: gql`
      baseProduct(id: $baseProductId) {
        selectedVariant(variantId: $variantId) {
          inactive
          variantLabel
          baseProductUrl
          id
          articleNumber
          variantName
          systemId
          purchaseQuantityFactor
          fields
          images {
            id
            filename
          }
          prices {
            originalPrice
            campaignPrice
          }
          customerPrices {
            originalPrice
            campaignPrice
          }
          showCustomerPrices
          priceFlag
          inStock
          packaging {
            packQuantity
            caption
          }
          stock {
            totalStockAvailable
            currentStock {
              amount
              date
            }
            incomingStock {
              date
              amount
            }
            expectedShippingDateTime
            deliveryDateFromSupplier
          }
          productRentalState {
            isRentedByCurrentOrganization
            isRentedByAnyOrganization
          }
          technicalSpecifications {
            id
            name
            value
          }
          isBundle
          bundledVariants {
            name
            url
            quantity
          }
        }
      }`,
    variables: {
      baseProductId: {
        value: data.articleNumber,
        type: 'String',
      },
      variantId: {
        value: command.query?.variant || '',
        type: 'String',
      },
    },
  });

  return data;
});
